import React from "react";
import PropTypes from "prop-types";
import { displayVarsomePremiumLogo } from "../../../../../../../common/helpers/helpers";
import HelperText from "../../../../../../../components/atoms/HelperText";

const EngineCell = ({ database, customStyle }) => {
  return (
    <>
      <div style={customStyle} />
      {database.url ? (
        <span>
          <a href={database.url} target="_blank">
            {database.name}
          </a>
        </span>
      ) : (
        <span>{database.name}</span>
      )}
      <HelperText fieldDescriptionKey={database.name} />

      {database.isPremium && displayVarsomePremiumLogo(false)}
    </>
  );
};

EngineCell.propTypes = {
  database: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    isPremium: PropTypes.bool,
  }).isRequired,
  customStyle: PropTypes.shape({}),
};

EngineCell.defaultProps = {
  customStyle: {},
};

export default EngineCell;
